import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import Utils from "../../../core/shared/utils";
import { MatStepper } from "@angular/material";
import { ISOTService, ISOTVoucher } from '../../services/ISOTService';
import * as Models from "../../models";

export interface VoucherDialogDataConfig {
  /** verweis auf den Service */
  sotService: ISOTService;
}

enum StepperIndex {
  voucher,
  payment
}

enum VoucherOptions {
  payAndBonus = "payAndBonus",
  onlyBonus = "onlyBonus",
  onlyPay = "onlyPay",
}

@Component({
  selector: "voucherpayDialog",
  templateUrl: "./voucherPayDialog.component.html",
  styleUrls: ["./voucherPayDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VoucherPayDialogComponent implements OnInit {
  public get allowVoucherPay(): boolean { return this._config.sotService.allowVoucherPay };
  public get useBonussystem(): boolean { return this._config.sotService.useBonussystem };
  public get voucher(): ISOTVoucher { return this._config.sotService.voucher };
  public get basketPriceWithoutDiscount(): number { return this._config.sotService.GetBasket().getTotalSumWithoutDiscount() };
  public get basketPrice(): number { return this._config.sotService.GetBasket().getTotalSum() };
  public get tipPercent(): number { return this._config.sotService.tipPercentage };
  public get remainingAmount(): number { return this._config.sotService.remainingAmount };
  public get allowTerminalPay(): boolean { return this._config.sotService.payAtTerminal };
  public get allowPosPay(): boolean { return this._config.sotService.payAtPOS };

  public selectedVoucherOption: string = "";
  public voucherOptions = VoucherOptions;
  public selectedIndex: number;
  public stepperIndex = StepperIndex;
  public paymentType = Models.PaymentType;
  public animateContent: boolean = false;

  @ViewChild('stepper') private _stepper: MatStepper;

  public constructor(public dialogRef: MatDialogRef<VoucherPayDialogComponent, Models.PaymentType>
    , @Inject(MAT_DIALOG_DATA) private _config: VoucherDialogDataConfig) {
  }

  ngOnInit() {
    const me = this;
    me.selectedIndex = me.stepperIndex.voucher;
  }

  /** Wert ist gröser 0 */
  public hasValue(value: number): boolean {
    return value && value > 0;
  }

  /** der Gutschein hat einen Wert */
  public hasSomeBalance(): boolean {
    const me = this;
    return me.hasValue(me._config.sotService.voucher.Amount)
      || me.hasValue(me._config.sotService.voucher.InviteAmount)
      //|| me.hasValue(me._config.sotService.voucher.BalanceBonus)
      || me.hasValue(me._config.sotService.voucher.Discount);
  }
  public get isModeOne(): boolean {
    return this._config.sotService.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this._config.sotService.Accessabilty.useModeTwo;
  }
  /**Replace the last 4 characters with '*'*/
  public get replaceVoucherChar() {
    return this._config.sotService.voucher.Code.replace(/(.{14})(.{4})/, '$1****');
  }

  public get sumTotal(): number {
    const me = this;
    return (me.hasValue(me._config.sotService.voucher.Discount) ? me.basketPrice : me.basketPriceWithoutDiscount) + me.tipAmount;
  }

  /** Berechnet den Betrag für Trinkgeld */
  public get tipAmount(): number {
    const me = this;
    return Utils.moneyRound(me.basketPrice * (me.tipPercent / 100.0));
  }

  /** option selected by User*/
  public setVoucherOption(option: string) {
    const me = this;
    return me.selectedVoucherOption = option
  }

  /** option selected by User*/
  public selectedPaymentOptions(paymentOption: Models.PaymentType): void {
    const me = this;
    me.dialogRef.close(paymentOption);
  }

  /** Canceled by User */
  public cancel(): void {
    const me = this;
    me.dialogRef.close(null)
  }

  /** mat stepper */
  private _nextStep(next: boolean): void {
    const me = this;
    if (next) {
      me.selectedIndex += me.stepperIndex.payment;
      if (me._stepper) {
        me._stepper.next();
        me.animateContent = true;
      }
    }
  }

  public continue(): void {
    const me = this;
    const payWithVoucher = me.selectedVoucherOption !== me.voucherOptions.onlyBonus;
    me._config.sotService.voucherSelectedForPay = payWithVoucher;
    if (me.selectedVoucherOption === me.voucherOptions.onlyBonus) {
      me._nextStep(true);
    } else {
      if (me.remainingAmount === 0) {
        me.dialogRef.close(me.paymentType.voucherPay);
      } else {
        // rest muss noch bezahlt werden
        me._nextStep(true);
      }
    }
  }

  public formatCurrency(price: number) {
    return Utils.currencyFormatter(price);
  }

  public get voucherBalace() {
    const me = this;
    return (Math.min(me.voucher.Amount + me.voucher.InviteAmount, me.sumTotal));
  }

}